import Card from "@kikoff/components/src/v1/cards/Card";

import styles from "./account_not_found_card.module.scss";

interface AccountNotFoundCardProps {}

export default function AccountNotFoundCard({}: AccountNotFoundCardProps) {
  return (
    <Card className={styles["account-not-found-card"]}>Account not found</Card>
  );
}
